// @ts-nocheck
import styled from "styled-components";
import React from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

export const ReferralsContentContainer = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.spacing.medium,
    padding: theme.spacing.medium,
    paddingTop: theme.spacing.xLarge,
    paddingBottom: theme.spacing.xLarge,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.medium,
}));

export const ReferralItem = styled.div<React.HTMLAttributes<HTMLDivElement>>(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.small,
}));

export const ReferralDivider = styled.div(({ theme }) => ({
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: theme.colors[theme.colorMode].border_Secondary,
}));

export const ReferralImage = styled(Image)(() => ({
    width: 48,
    height: 48,
    borderRadius: "50%",
    objectFit: "cover" as const,
}));

export const ReferralInfo = styled.div<React.HTMLAttributes<HTMLDivElement>>(() => ({
    display: "flex",
    flexDirection: "column" as const,
    gap: 2,
}));

export const ReferralName = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
}));

export const ReferralEarning = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].positive,
}));

interface IStatusTagContainer extends React.HTMLAttributes<HTMLDivElement> {
    $backgroundColor: string;
}

export const StatusTagContainer = styled.div<IStatusTagContainer>(
    ({ theme }) => ({
        paddingTop: theme.spacing.xxSmall,
        paddingBottom: theme.spacing.xxSmall,
        paddingLeft: 6,
        paddingRight: 6,
        borderRadius: 6,
        alignItems: "center",
        width: "fit-content",
        display: "flex",
    }),
    ({ $backgroundColor }) => ({
        backgroundColor: $backgroundColor,
    }),
);

export const StatusTagText = styled(Text)({
    margin: 0,
});

export const ViewAllTextButton = styled(TextButton)(({ theme }) => ({
    marginTop: -theme.spacing.xSmall,
    marginBottom: -theme.spacing.small,
}));

export const ChevronIconContainer = styled.div(({ theme }) => ({
    height: 20,
    width: 20,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors[theme.colorMode].background_Secondary,
    marginLeft: "auto",
}));
